<script>
    import AddressesMap from '../../../shared/components/Addresses/AddressesMap';

    export default {
        extends: AddressesMap,

        props: {
            selectedStatus: {
                type: String,
                default: 'all',
            },
            sidebarVisible: {
                type: Boolean,
                default: false,
            },
            clickable: {
                type: Boolean,
            },
        },
    };
</script>
